import GDCLogo from './GDCLogo';
export {
  GDCLogo
};
